import en from './en';
import es from './es';
import ru from './ru';

export default {
  en,
  ru,
  es,
};
